// @ts-nocheck
/*
 * Port of session-replay/components/HeatmapOverlay.js (67 lines). BYTE-IDENTICAL.
 * Radial-gradient click heatmap layered over the current screen. Blue →
 * red as click density approaches maxClicks; any cell with rage_clicks
 * forces the hottest hue.
 */
import React, { useEffect, useRef } from 'react';

export default function HeatmapOverlay({ cells = [], maxClicks = 0, screen }: any) {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const parent = canvas.parentElement;
    const width = parent?.clientWidth || 800;
    const height = parent?.clientHeight || 600;
    canvas.width = width;
    canvas.height = height;

    const ctx = canvas.getContext('2d')!;
    ctx.clearRect(0, 0, width, height);
    if (!cells.length || !maxClicks) return;

    const radius = Math.max(14, Math.round(width / 50));
    for (const cell of cells) {
      const cx = ((cell.gx + 0.5) / 100) * width;
      const cy = ((cell.gy + 0.5) / 100) * height;
      const intensity = Math.min(1, cell.clicks / maxClicks);
      const isRage = cell.rage_clicks > 0;

      const grad = ctx.createRadialGradient(cx, cy, 0, cx, cy, radius);
      const hue = isRage ? 0 : 220 - intensity * 160; // blue -> red as density rises
      grad.addColorStop(0, `hsla(${hue}, 90%, 55%, ${0.25 + intensity * 0.45})`);
      grad.addColorStop(1, `hsla(${hue}, 90%, 55%, 0)`);
      ctx.fillStyle = grad;
      ctx.beginPath();
      ctx.arc(cx, cy, radius, 0, Math.PI * 2);
      ctx.fill();
    }
  }, [cells, maxClicks]);

  return (
    <>
      <canvas
        ref={canvasRef}
        style={{
          position: 'absolute',
          inset: 0,
          pointerEvents: 'none',
          zIndex: 5,
        }}
      />
      <div
        style={{
          position: 'absolute',
          top: 8,
          left: 8,
          zIndex: 6,
          background: 'rgba(17,24,39,0.8)',
          color: '#fff',
          fontSize: 12,
          padding: '4px 10px',
          borderRadius: 6,
          pointerEvents: 'none',
        }}
      >
        🔥 Click heatmap — {screen || 'current screen'}
        {!cells.length ? ' (no clicks recorded)' : ''}
      </div>
    </>
  );
}
